class TCCCartDrawer extends HTMLElement {
    constructor() {
        super();
        // Bind the method once to maintain reference
        this.handleOpenCart = () => this.openCart();
        this.handleCartItemClick = (e) => this.handleCartItemInteractions(e);
        this.sectionId = this.getAttribute('data-section-id');
    }

    connectedCallback() {
        // Cache DOM elements
        this.cartItemsContainer = this.querySelector('.g-cart-items');
        this.cartCountEl = this.querySelector('.cart-count');
        this.cartTotalEl = this.querySelector('.cart-total');
        this.cartContent = this.querySelector('#g-cart-content');
        this.cartDrawer = this.querySelector('#g-cart-content .g-cart-drawer');
        this.cartOverlay = this.querySelector('.g-cart-overlay');
        this.closeButton = this.querySelector('.g-close');
        this.upsellButtons = this.querySelectorAll('.g-cart-upsell-content button');
        this.checkoutBtn = this.querySelector('.g-cart-checkout');

        // Read Liquid-rendered values from data attributes, these are used for the FREEGIFT algorithm
        this.freeProductId = parseInt(this.dataset.freeProductId);
        this.freeProductVariantId = parseInt(this.dataset.freeProductVariantId);
        this.sectionId = this.dataset.sectionId;
        this.freegiftEnabled = this.dataset.freegiftEnabled === 'true';
        this.freegiftThreshold = parseInt(this.dataset.freegiftThreshold) || 0;
        this.stocklabel = this.dataset.stocklabel;

        // FREE GIFTS Feature
        this.freegiftProductIds = (this.dataset.freegiftProductIds || '').split(',').map(Number).filter(Boolean);
        this.freegiftVariantIds = (this.dataset.freegiftVariantIds || '').split(',').map(Number).filter(Boolean);
        this.triggerProductIds = (this.dataset.triggerProductIds || '').split(',').map(Number).filter(Boolean);

        // Pulse
        this.pulseTimer = this.querySelector("#g-bottom-text");
        this.pulseMin = parseInt(this.getAttribute('data-timer-min'));
        this.pulseMax = parseInt(this.getAttribute('data-timer-max'));

        if (this.pulseTimer) {
            const getRandomPeople = () => Math.floor(Math.random() * (this.pulseMax - this.pulseMin + 1)) + this.pulseMin;

            const updatePulse = () => {
                const randomPeople = getRandomPeople();
                this.pulseTimer.innerHTML = `<p><strong>${randomPeople}</strong> ${this.stocklabel}</p>`;
            };

            updatePulse(); // run immediately
            clearInterval(this.pulseInterval); // prevent duplicates on refreshCart
            this.pulseInterval = setInterval(updatePulse, 4000);
        }

        // Upsell Random
        this.upsellLabelElement = this.querySelector('#g-upsell-label-title');
        this.upsellLabelText = this.getAttribute('data-upsell-label');
        this.upsellMin = parseInt(this.getAttribute('data-upsell-min'));
        this.upsellMax = parseInt(this.getAttribute('data-upsell-max'));

        if (this.upsellLabelElement) {
            const storageKey = 'g-upsell-random';
            let randomPeople = localStorage.getItem(storageKey);

            if (!randomPeople) {
                randomPeople = Math.floor(Math.random() * (this.upsellMax - this.upsellMin + 1)) + this.upsellMin;
                localStorage.setItem(storageKey, randomPeople);
            }

            this.upsellLabelElement.innerHTML = this.upsellLabelText.replace('[X]', `${randomPeople}%`);
        }

        // Toggle Shipping Insurance
        this.productToggle = this.querySelector('.g-cart-cta .product-toggle input[type="checkbox"]');
        if (this.productToggle) {
            this.handleProductToggle = async (e) => {
                const isChecked = e.target.checked;
                const variantId = parseInt(e.target.dataset.vid);

                if (isChecked) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: 1,
                            sections: `${this.sectionId},get-cart-bubble`
                        })
                    });
                    this.refreshCart();
                } else {
                    // First find the line item key
                    const cartRes = await fetch('/cart.js');
                    const cart = await cartRes.json();
                    const item = cart.items.find(i => i.variant_id === variantId);

                    if (item) {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: 0,
                                sections: `${this.sectionId},get-cart-bubble`
                            })
                        });
                        this.refreshCart();
                    }
                }
            };

            this.productToggle.removeEventListener('change', this.handleProductToggle);
            this.productToggle.addEventListener('change', this.handleProductToggle);
        }

        // Additional Days
        this.deliveryDateEl = this.querySelector('#g-delivery-date');
        this.additionalDays = parseInt(this.dataset.additionalDays) || 0;

        if (this.additionalDays > 0) {
            this.updateDeliveryDate(this.additionalDays);
        }


        // Countdown timer
        this.countTimerDate = this.getAttribute("data-count-timer-date");
        this.countTimerTime = this.getAttribute("data-count-timer-hours");
        if(this.countTimerDate || this.countTimerTime){
            console.log("EHHH?");
            this.startCountdownTimer();
        }

        // Checkout Button
        if (this.checkoutBtn) {
            this.checkoutBtn.addEventListener('click', () => {
                window.location.href = '/checkout';
            });
        }


        // Mini Timer
        this.startMiniTimer();


        // Remove any existing listener before adding a new one
        document.removeEventListener('gOpenCart', this.handleOpenCart);
        document.addEventListener('gOpenCart', this.handleOpenCart);

        // Add close button listener (remove old one first if it exists)
        if (this.closeButton) {
            this.closeButton.removeEventListener('click', this.boundCloseCart);
            this.boundCloseCart = () => this.closeCart();
            this.closeButton.addEventListener('click', this.boundCloseCart);
        }

        if (this.cartOverlay) {
            this.cartOverlay.removeEventListener('click', this.boundCloseCartOverlay);
            this.boundCloseCartOverlay = () => this.closeCart();
            this.cartOverlay.addEventListener('click', this.boundCloseCartOverlay);
        }

        // Use event delegation for cart items
        if (this.cartItemsContainer) {
            // Remove listener before adding to prevent duplicates
            this.cartItemsContainer.removeEventListener('click', this.handleCartItemClick);
            this.cartItemsContainer.addEventListener('click', this.handleCartItemClick);
        }

        // Remove old listeners and re-add for each upsell button
        this.upsellButtons.forEach(btn => {
            btn.removeEventListener('click', this.handleUpsellClick);
            btn.addEventListener('click', this.handleUpsellClick);
        });

        this.initSwiper();
        this.initSelectListeners();
    }

    disconnectedCallback() {
        // Clean up when element is removed
        document.removeEventListener('gOpenCart', this.handleOpenCart);
        if (this.cartItemsContainer) {
            this.cartItemsContainer.removeEventListener('click', this.handleCartItemClick);
        }

        clearInterval(this.countdownInterval);
        clearInterval(this.miniTimerInterval);
        clearInterval(this.pulseInterval);
    }


    // Mini Timer
    startMiniTimer() {
        const miniTimerEl = this.querySelector('#g-mini-timer');
        if (!miniTimerEl) return;

        const minutes = parseInt(this.dataset.miniTimerMinutes);
        if (!minutes) return;

        const storageKey = `g-mini-timer-target-${minutes}`;
        let targetDate;

        const saved = localStorage.getItem(storageKey);
        if (saved) {
            targetDate = new Date(parseInt(saved));
        } else {
            targetDate = new Date(Date.now() + minutes * 60 * 1000);
            localStorage.setItem(storageKey, targetDate.getTime());
        }

        const reset = () => {
            targetDate = new Date(Date.now() + minutes * 60 * 1000);
            localStorage.setItem(storageKey, targetDate.getTime());
        };

        const originalText = miniTimerEl.innerHTML;

        const update = () => {
            const diff = targetDate - new Date();

            if (diff <= 0) {
                reset();
                return;
            }

            const m = Math.floor(diff / (1000 * 60));
            const s = Math.floor((diff % (1000 * 60)) / 1000);
            const display = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;

            miniTimerEl.innerHTML = originalText.replace('[X]', `<b>${display}</b>`);
        };

        update();
        clearInterval(this.miniTimerInterval);
        this.miniTimerInterval = setInterval(update, 1000);
    }


    startCountdownTimer() {
        const daysEl = this.querySelector('#g-lt-days');
        const hoursEl = this.querySelector('#g-lt-hours');
        const minutesEl = this.querySelector('#g-lt-minutes');
        const secondsEl = this.querySelector('#g-lt-seconds');

        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

        const storageKey = 'g-timer-target';

        const getOrCreateTarget = () => {
            // If date is not set, clear any old date-based storage and use hours instead
            if (!this.countTimerDate) {
                localStorage.removeItem('g-timer-target-date');

                const savedHours = localStorage.getItem('g-timer-target-hours');
                if (savedHours) return new Date(parseInt(savedHours));

                if (!this.countTimerTime) return null;

                const targetDate = new Date(Date.now() + parseInt(this.countTimerTime) * 60 * 60 * 1000);
                localStorage.setItem('g-timer-target-hours', targetDate.getTime());
                return targetDate;
            }

            // Date is set, clear any old hours-based storage and use date instead
            localStorage.removeItem('g-timer-target-hours');

            const savedDate = localStorage.getItem('g-timer-target-date');
            if (savedDate) return new Date(parseInt(savedDate));

            const targetDate = new Date(this.countTimerDate);
            localStorage.setItem('g-timer-target-date', targetDate.getTime());
            return targetDate;
        };

        const reset = () => {
            // Remove the correct keys so getOrCreateTarget creates a fresh target
            localStorage.removeItem('g-timer-target-hours');
            localStorage.removeItem('g-timer-target-date');
            return getOrCreateTarget();
        };

        const update = () => {
            let targetDate = getOrCreateTarget();
            if (!targetDate) return;

            let diff = targetDate - new Date();

            if (diff <= 0) {
                targetDate = reset();
                if (!targetDate) return;
                diff = targetDate - new Date(); // recalculate diff with new target
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            daysEl.textContent = String(days).padStart(2, '0');
            hoursEl.textContent = String(hours).padStart(2, '0');
            minutesEl.textContent = String(minutes).padStart(2, '0');
            secondsEl.textContent = String(seconds).padStart(2, '0');
        };

        update();
        clearInterval(this.countdownInterval);
        this.countdownInterval = setInterval(update, 1000);
    }

    getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    updateDeliveryDate(daysToAdd) {
        if (!this.deliveryDateEl) return;

        const today = new Date();
        const deliveryDate = new Date(today);
        deliveryDate.setDate(today.getDate() + daysToAdd);

        const month = deliveryDate.toLocaleString('default', { month: 'short' });
        const day = deliveryDate.getDate();
        const suffix = this.getOrdinalSuffix(day);

        this.deliveryDateEl.textContent = `${month} ${day}${suffix}`;
    }



    // TIER FREE GIFT
    async checkFreeProduct() {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        let hasSubscription = false;
        let freeProductExisting = false;
        let freeProductLineKey = null;

        cart.items.forEach((item) => {
            if (item.selling_plan_allocation) hasSubscription = true;
            if (item.product_id === this.freeProductId) {
                freeProductExisting = true;
                freeProductLineKey = item.key;
            }
        });

        console.log(hasSubscription, freeProductExisting);
        console.log(this.freegiftEnabled, this.freegiftThreshold);

        if (this.freegiftEnabled && cart.total_price >= this.freegiftThreshold && this.freeProductId) {
            if (!freeProductExisting) {
                const addRes = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({
                        id: this.freeProductVariantId,
                        quantity: 1,
                        sections: `${this.sectionId},get-cart-bubble`
                    })
                });
                
                if (!addRes.ok) {
                    console.warn('Free gift could not be added (possibly out of stock), skipping.');
                    return; // ← bail out, don't refreshCart
                }

                this.refreshCart();
            }
        } else {
            if (freeProductExisting) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: freeProductLineKey,
                        quantity: 0,
                        sections: `${this.sectionId},get-cart-bubble`
                    })
                });
                this.refreshCart();
            }
        }

        this.checkAutoFreeGifts(cart);
    }


    // AUTO FREEGIFT
    async checkAutoFreeGifts(cart) {
        const cartProductIds = cart.items.map(i => i.product_id);
        const hasTriggerProduct = this.triggerProductIds.some(id => cartProductIds.includes(id));

        console.log(cartProductIds, hasTriggerProduct);

        if (hasTriggerProduct) {
            // Filter only gifts not already in cart
            const toAdd = this.freegiftVariantIds.filter((variantId, i) => {
                return !cartProductIds.includes(this.freegiftProductIds[i]);
            }).map(id => ({ id, quantity: 1, properties: { _free_gift: true } }));

            if (toAdd.length > 0) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ items: toAdd })
                });

                this.refreshCart();
            }
        } else {
            // Build updates object { key: 0 } for all free gifts in cart
            const updates = {};
            cart.items.forEach(item => {
                if (this.freegiftProductIds.includes(item.product_id)) {
                    updates[item.key] = 0;
                }
            });

            if (Object.keys(updates).length > 0) {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });

                this.refreshCart();
            }
        }
    }


    handleCartItemInteractions(e) {
        const target = e.target;
        const item = target.closest('.g-cart-item');
        if (!item) return;

        const quantity = item.querySelector(".g-ci-quantity");

        // Check if target or its parent is the plus button
        const plusButton = target.closest('.g-ci-quantity-plus');
        const minusButton = target.closest('.g-ci-quantity-minus');
        const removeButton = target.closest('.g-remove');
        const checkbox = target.closest('.g-ci-sub-check');

        // Handle checkbox clicks
        if (checkbox) {
            const isChecked = item.classList.toggle("active");
            checkbox.setAttribute("aria-checked", isChecked ? "true" : "false");
            item.dataset.checked = isChecked;

            console.log("Item checked:", isChecked);
            const defaultSP = checkbox.getAttribute("data-default-sp");
            const currentSP = checkbox.getAttribute("data-current-sp");
            const cbLine = checkbox.getAttribute("data-line");
            const inputQty = parseInt(quantity.innerHTML);
            console.log(defaultSP, currentSP);
            
            if(isChecked){
                if(currentSP == ""){
                    updateCartSellingPlan(cbLine, inputQty, defaultSP);
                }
            }else{
                if(currentSP){
                    updateCartSellingPlan(cbLine, inputQty, "");
                }
            }
        }

        // Handle plus button
        if (plusButton) {
            const key = parseInt(plusButton.getAttribute("data-line"));
            let inputQty = parseInt(quantity.innerHTML);
            inputQty += 1;
            quantity.innerHTML = inputQty;
            this.updateCartQuantity(key, inputQty);
        }

        // Handle minus button
        if (minusButton) {
            const key = parseInt(minusButton.getAttribute("data-line"));
            let inputQty = parseInt(quantity.innerHTML);
            inputQty -= 1;
            quantity.innerHTML = inputQty;
            this.updateCartQuantity(key, inputQty);
        }

        // Handle remove button
        if (removeButton) {
            const key = parseInt(removeButton.getAttribute("data-line"));
            this.updateCartQuantity(key, 0);
        }
    }

    initSelectListeners() {
        // Handle variant selects separately (change events)
        this.querySelectorAll(".g-cart-item-subscription select").forEach(select => {
            // Remove existing listener if any
            const newSelect = select.cloneNode(true);
            select.parentNode.replaceChild(newSelect, select);
            
            newSelect.addEventListener("change", async(e) => {
                const sp = e.target.value;
                const key = e.target.getAttribute("data-key");
                const qty = e.target.getAttribute("data-qty");

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: key,
                        quantity: qty,
                        selling_plan: sp
                    })
                })
                .then(res => res.json())
                .then(cart => this.refreshCart() )
                .catch(err => console.error(err));
            });
        });
    }

    handleUpsellClick = (e) => {
        const btn = e.currentTarget;
        const vid = btn.getAttribute("data-vid");
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: vid,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            this.refreshCart();
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
        });
    }

    async initSwiper() {
        await this.loadSwiperAssets();
        new Swiper('.g-cart-upsells-slider', {
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.g-cus-next',
                prevEl: '.g-cus-prev',
            }
        });
    }

    async loadSwiperAssets() {
        const promises = [];

        if (!window.Swiper) {
          promises.push(this.loadScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'));
        }

        if (!document.querySelector('link[href*="swiper"]')) {
          promises.push(this.loadStylesheet('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'));
        }

        if (promises.length > 0) {
          await Promise.all(promises);
        }
      }

      loadScript(src) {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      loadStylesheet(href) {
        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          link.onload = resolve;
          link.onerror = reject;
          document.head.appendChild(link);
        });
      }

    async updateCartQuantity(key, qty){
    this._pendingQty = this._pendingQty || {};
    this._pendingQty[key] = qty;
    if (this._qtyTimer) clearTimeout(this._qtyTimer);
    const flush = () => {
      const updates = this._pendingQty || {};
      this._pendingQty = {};
      const lines = Object.keys(updates);
      if (!lines.length) return;
      const send = (i) => {
        if (i >= lines.length) { this.refreshCart(); return; }
        fetch(`/cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(lines[i]), quantity: updates[lines[i]] })
        })
        .then(response => response.json())
        .then(() => send(i + 1))
        .catch(error => {
          console.error('Error updating cart:', error);
          this.refreshCart();
        });
      };
      send(0);
    };
    if (qty <= 0) { flush(); } else { this._qtyTimer = setTimeout(flush, 300); }
  }

  async refreshCart() {
        const locale = (document.documentElement.lang || 'en').toLowerCase();
        console.log(locale);
        
        // Use the section ID instead of the file name
        const res = await fetch(`/${locale}?sections=${this.sectionId}`);
        const data = await res.json();

        const parser = new DOMParser();
        const doc = parser.parseFromString(data[this.sectionId], 'text/html');
        const cart_content = doc.querySelector('#g-cart-content .g-cart-drawer');
        
        if (cart_content && this.cartContent) {
            this.cartDrawer.innerHTML = cart_content.innerHTML;
        }
        
        console.log("From tcc-cart-drawer", this.cartContent);

        this.checkFreeProduct();

        // Re-initialize after content update
        this.connectedCallback();
    }

    openCart() {
        this.style.visibility = "visible";
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector("html").style.overflow = "hidden";
        document.body.classList.add('g-cart-is-open');

        if (this.cartContent) {
            this.cartContent.classList.add('g-cart-open');
        }
        this.refreshCart();
    }

    closeCart() {
        this.style.visibility = "hidden";
        document.querySelector("body").style.overflow = "auto";
        document.querySelector("html").style.overflow = "auto";
        document.body.classList.remove('g-cart-is-open');

        if (this.cartContent) {
            this.cartContent.classList.remove('g-cart-open');
        }
    }
}

customElements.define('tcc-cart-drawer', TCCCartDrawer);


// INTERCEPT /cart click
document.addEventListener("click", function (e) {
    const link = e.target.closest("a");

    if (link && link.href.includes("/cart")) {
        e.preventDefault();
        document.dispatchEvent(new Event("gOpenCart"));
    }
});

// Listen for all form submissions on the page
document.addEventListener('submit', function(event) {
    const form = event.target;

    // Check if the form action includes "/cart/add" (or any other specific condition)
    if (form.action.includes('/cart/add')) {
        event.stopImmediatePropagation();
        event.preventDefault(); // Prevent the default form submission

        console.log('Intercepted form submission to /cart/add');

        // Create FormData object to get all form inputs
        const formData = new FormData(form);
        console.log(formData);

        // Use fetch to send the form data via POST
        fetch(form.action, {
            method: 'POST',
            body: formData,
        })
        .then(response => {
            // Check if the response is ok (status 200-299)
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text(); // Read the response as text
        })
        .then(text => {
            // Trigger custom 'cartshow' event after successful form submission
            document.dispatchEvent(new Event("gOpenCart"));
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
        });
    }
}, true);
